import { useEffect, useRef } from 'react'

import { useMemoizedFn, useUpdateEffect } from 'ahooks'
import { type ChartType, Chart as ChartJS } from 'chart.js/auto'

import { ChartProps } from './interface'

export const Chart = <TType extends ChartType = ChartType>({
  className,
  style,
  width,
  height,
  refreshDeps = [],
  type,
  data,
  options,
  platform,
  plugins
}: ChartProps<TType>) => {
  const chartRef = useRef<ChartJS<TType>>(null)
  const canvasRef = useRef<HTMLCanvasElement>(null)

  const renderChart = useMemoizedFn(() => {
    if (!canvasRef.current) {
      return
    }
    chartRef.current = new ChartJS(canvasRef.current, {
      type,
      data,
      options,
      platform,
      plugins
    })
  })

  const destroyChart = useMemoizedFn(() => {
    if (!chartRef.current) {
      return
    }
    chartRef.current.destroy()
    chartRef.current = null
  })

  useEffect(() => {
    renderChart()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useUpdateEffect(() => {
    destroyChart()
    renderChart()
  }, refreshDeps)

  return (
    <canvas
      ref={canvasRef}
      className={className}
      height={height}
      style={style}
      width={width}
    />
  )
}
